import styled from 'styled-components';
import { switchProp } from 'styled-tools';
import { fontTitle, fontAccent } from 'Styles/fonts';
import {
  bombasCream,
  bombasYellow,
  bombasSeafoam,
  bombasBlue,
  black
} from 'Styles/colors';

export const TopBlock = styled.div`
  display: flex;
  flex: 0 0 180px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 180px;
  ${fontTitle(36)};
  background: ${bombasBlue};
`;

export const BottomBlock = styled.div`
  display: flex;
  flex: 0 0 200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  ${fontAccent(32)};
  color: ${black};
  background: ${bombasCream};
`;

export const BottomFill = styled.div`
  flex: 1 1 auto;
  padding: 24px;
  background: ${bombasCream};
`;

export const Plain = styled.span`
  ${fontTitle(32)};
`;

export const Text = styled.p`
  display: block;
  margin: 0;
  padding: 0;
  color: ${switchProp('$color', {
    cream: bombasCream,
    yellow: bombasYellow,
    seafoam: bombasSeafoam
  })};
  text-align: ${switchProp('align', {
    left: 'left',
    right: 'right'
  })};
  width: 270px;
`;

export const Glyph = styled.span.attrs({ 'aria-hidden': true })`
  font-family: var(--glyph-font), sans-serif;
  font-variant: normal;
  user-select: none;
  color: ${switchProp('$color', {
    cream: bombasCream,
    yellow: bombasYellow,
    seafoam: bombasSeafoam
  })};
`;

export const SignUpSuccess = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
